import * as React from 'react';
import { useMarkerContext } from '../../../contexts/MarkerContext.js';
import { getFinalMarkerContent } from '../../../helpers/Marker.helpers.js';
import { useMarkerContent } from '../../../hooks/useMarker.js';
import { Typography } from '../../../../../Typography/Typography.js';

var MarkerContent = function MarkerContent(_ref) {
  var content = _ref.content;
  var _useMarkerContext = useMarkerContext(),
    size = _useMarkerContext.size;
  var markerContentProps = useMarkerContent(useMarkerContext());
  var markerContent = getFinalMarkerContent(size, content);
  if (size === 'xs') return null;
  return /*#__PURE__*/React.createElement(Typography, markerContentProps, markerContent);
};

export { MarkerContent };
//# sourceMappingURL=MarkerContent.js.map
